import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Header from '../../common/Header';
import PageContentPanel from '../panels/PageContentPanel';
import { DashboardTimelineType, OwnerType } from '../../../constants/ComponentTypes';


const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    overflowY: 'auto',
  },
});

class QRCodeReaction extends React.Component {
  initialState = {
    ownerType: OwnerType.OWN.value,
  }

  constructor(props) {
    super(props);
    const ownerType = props.location.state && props.location.state.ownerType ? props.location.state.ownerType : OwnerType.OWN.value;
    this.state = { ...this.initialState, ...{ ownerType: ownerType } };
  }

  componentDidMount() {
    this.props.getUserInfo();
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Header
          title="ダッシュボード"
          secondaryTitle={DashboardTimelineType.QR_CODE_REACTION.text}
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() => this.props.goTo('/order-dashboard', {
            ownerType: this.state.ownerType
          })}
        />
        <PageContentPanel
          type={DashboardTimelineType.QR_CODE_REACTION.value}
          items={this.props.list}
          goTo={this.props.goTo}
          isLoading={this.props.isLoading}
          pageInfo={this.props.pageInfo}
          ownerType={this.state.ownerType}
          getStatus={this.props.getPersonQrCodeStatus}
        />
      </div>
    )
  }
}

QRCodeReaction.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  pageInfo: PropTypes.object,
  getPersonQrCodeStatus: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  user: PropTypes.object,
  list: PropTypes.array,
  location: PropTypes.object,
};

export default withStyles(styles)(QRCodeReaction);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/pages/QRCodeReaction.jsx